import React, { useState, useEffect } from "react";
import axios from "axios";
import { Apiurl } from "../../shared/services/apirest";
import AdminLayout from "../../modules/dashboard/AdminLayout";
import "bootstrap/dist/css/bootstrap.min.css";

import LocationService from "../../shared/services/LocationService";
// We are migrating, so we should try to use the API. 
// However, getMunicipioDefaultCoords was checking Urbana first. 
// We should implement handleMunicipioChange using the API data we fetch.

const New = () => {
  const [laboratorios, setLaboratorios] = useState([]);
  const [selectedLabId, setSelectedLabId] = useState("");
  const [municipiosList, setMunicipiosList] = useState([]); // [ {id, nombre, ...} ]
  const [locationsHierarchy, setLocationsHierarchy] = useState({});

  const [formData, setFormData] = useState({
    email: "",
    password: "",
    nombre_laboratorio: "",
    direccion: "",
    telefonos: "",
    horario: "",
    latitud: "",
    longitud: "",
    municipio: "Ayapel",
    departamento: "Córdoba",
    role: "laboratorio",
  });

  const [currentUserRole, setCurrentUserRole] = useState("");
  const [availableRoles, setAvailableRoles] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const user = JSON.parse(localStorage.getItem("userData") || "{}");
    const role = user.role || "";
    setCurrentUserRole(role);

    // Initial role setup based on Admin Type
    let roles = [];
    if (role === "admin_lab") {
      roles = [{ value: "laboratorio", label: "Laboratorio" }];
      setFormData(prev => ({ ...prev, role: "laboratorio" }));
    } else if (role === "admin_investigacion") {
      roles = [{ value: "investigador", label: "Investigador" }];
      setFormData(prev => ({ ...prev, role: "investigador" }));
    } else {
      // Global Admin
      roles = [
        { value: "laboratorio", label: "Laboratorio" },
        { value: "investigador", label: "Investigador" },
        { value: "admin_lab", label: "Admin Laboratorios" },
        { value: "admin_investigacion", label: "Admin Investigadores" },
        { value: "visualizador", label: "Visualizador" },
      ];
    }
    setAvailableRoles(roles);

    // Fetch Locations from API
    const fetchLocations = async () => {
      try {
        const hierarchy = await LocationService.getHierarchy();
        setLocationsHierarchy(hierarchy);
        setMunicipiosList(Object.keys(hierarchy));

        // Set default coords for initial value if needed
        // setFormData(prev => ...)
      } catch (error) {
        console.error("Error loading locations", error);
      }
    };
    fetchLocations();

  }, []);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleMunicipioChange = (e) => {
    const municipioName = e.target.value;

    // Find coords in the hierarchy
    let lat = "";
    let lng = "";

    if (locationsHierarchy[municipioName]) {
      // Try Urbana -> Centro
      const urb = locationsHierarchy[municipioName]["Urbana"];
      if (urb && urb["Centro"]) {
        lat = urb["Centro"].lat;
        lng = urb["Centro"].lng;
      } else if (urb) {
        const first = Object.values(urb)[0];
        if (first) { lat = first.lat; lng = first.lng; }
      } else {
        // Try Rural
        const rur = locationsHierarchy[municipioName]["Rural"];
        if (rur) {
          const first = Object.values(rur)[0];
          if (first) { lat = first.lat; lng = first.lng; }
        }
      }
    }

    setFormData({
      ...formData,
      municipio: municipioName,
      latitud: lat,
      longitud: lng,
    });
  };

  // 🔐 VALIDACIÓN EXCLUSIVA DEL EMAIL
  const handleEmailChange = (e) => {
    let value = e.target.value.trim();
    if (!value.includes("@")) {
      setFormData({ ...formData, email: value });
      return;
    }
    const [user] = value.split("@");
    const emailFinal = `${user}@geohcx.com`;
    setFormData({ ...formData, email: emailFinal });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    // Sanitize payload: valid numbers or null
    const payload = {
      ...formData,
      latitud: formData.latitud === "" ? null : formData.latitud,
      longitud: formData.longitud === "" ? null : formData.longitud,
      // Ensure cod_laboratorio is not sent as empty string if it exists in formData
      cod_laboratorio: formData.cod_laboratorio === "" ? null : formData.cod_laboratorio,
    };

    try {
      await axios.post(`${Apiurl}users/Create_User/`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      alert("Usuario creado correctamente");
    } catch (err) {
      console.error("Error creating user:", err);
      const errorData = err.response?.data || {};
      let msg = "Error al crear usuario:\n";
      if (typeof errorData === 'object') {
        Object.entries(errorData).forEach(([key, val]) => {
          msg += `- ${key}: ${Array.isArray(val) ? val.join(" ") : val}\n`;
        });
      } else {
        msg += String(errorData);
      }
      alert(msg);
    }
  };

  return (
    <AdminLayout title="Registrar Usuario">
      <div className="container mt-4">
        <form
          onSubmit={handleSubmit}
          className="bg-light p-4 rounded-4 shadow"
        >
          <div className="row g-4 mb-4">
            <div className="col-md-6">
              <label className="form-label fw-semibold">
                Email (solo dominio @geohcx.com)
              </label>
              <input
                type="email"
                name="email"
                className="form-control shadow-sm"
                value={formData.email}
                onChange={handleEmailChange}
                required
              />
            </div>

            <div className="col-md-6">
              <label className="form-label fw-semibold">Password</label>
              <input
                type="password"
                name="password"
                className="form-control shadow-sm"
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-6">
              <label className="form-label fw-semibold">Rol de Usuario</label>
              <select
                name="role"
                className="form-select shadow-sm"
                value={formData.role}
                onChange={handleChange}
                disabled={["admin_lab", "admin_investigacion"].includes(currentUserRole)}
              >
                {availableRoles.map(r => (
                  <option key={r.value} value={r.value}>{r.label}</option>
                ))}
              </select>
            </div>
          </div>

          {/* Standardized Information Section for ALL roles */}
          <h5 className="mb-3 fw-bold text-secondary">
            Información de la Entidad / Usuario
          </h5>
          <div className="mb-4">
            <label className="form-label fw-semibold">
              Nombre de la Entidad / Laboratorio
            </label>
            <input
              name="nombre_laboratorio"
              className="form-control shadow-sm"
              value={formData.nombre_laboratorio}
              onChange={handleChange}
              placeholder="Ej. Laboratorio Central, Investigador Juan Perez..."
              required
            />
          </div>

          <div className="row g-4 mb-4">
            <div className="col-md-6">
              <label className="form-label fw-semibold">Dirección Física</label>
              <input
                name="direccion"
                className="form-control shadow-sm"
                value={formData.direccion}
                onChange={handleChange}
                placeholder="Dirección completa"
              />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold">Teléfonos</label>
              <input
                name="telefonos"
                className="form-control shadow-sm"
                value={formData.telefonos}
                onChange={handleChange}
                placeholder="Ej. 3001234567, 7894561"
              />
            </div>
          </div>

          <div className="row g-4 mb-4">
            <div className="col-md-6">
              <label className="form-label fw-semibold">Municipio</label>
              <select
                name="municipio"
                className="form-select shadow-sm"
                value={formData.municipio}
                onChange={handleMunicipioChange}
              >
                {municipiosList.map(m => (
                  <option key={m} value={m}>{m}</option>
                ))}
              </select>
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold">Departamento</label>
              <input
                name="departamento"
                className="form-control shadow-sm"
                value={formData.departamento}
                onChange={handleChange}
                placeholder="Ej. Córdoba"
              />
            </div>
          </div>

          <div className="row g-4 mb-4">
            <div className="col-md-12">
              <label className="form-label fw-semibold">Horario de Atención</label>
              <input
                name="horario"
                className="form-control shadow-sm"
                value={formData.horario}
                onChange={handleChange}
                placeholder="Ej. Lunes a Viernes 7:00 AM - 5:00 PM"
              />
            </div>
          </div>

          <div className="row g-4 mb-4">
            <div className="col-md-6">
              <label className="form-label fw-semibold">Latitud</label>
              <input
                name="latitud"
                className="form-control shadow-sm"
                value={formData.latitud}
                onChange={handleChange}
                placeholder="Ej. 8.456"
              />
            </div>

            <div className="col-md-6">
              <label className="form-label fw-semibold">Longitud</label>
              <input
                name="longitud"
                className="form-control shadow-sm"
                value={formData.longitud}
                onChange={handleChange}
                placeholder="Ej. -75.123"
              />
            </div>
          </div>

          <div className="text-end">
            <button className="btn btn-success px-4 py-2 shadow">
              Crear Usuario
            </button>
          </div>
        </form>
      </div>
    </AdminLayout>
  );
}

export default New;
